export default {
  language: 'Português',
  businessSectors: {
    title: 'Selecione até 3 Setores de Negócio',
    selected: 'Selecionados',
    maxSelectionAlert: 'Você pode selecionar até 3 setores de negócio',
  },
  characteristics: {
    title: 'Selecione até 3 Características',
    selected: 'Selecionadas',
    maxSelectionAlert: 'Você pode selecionar até 3 características',
  },
  errors: {
    loadOptions: 'Falha ao carregar opções. Por favor, tente novamente mais tarde.',
    minSelection: 'Por favor, selecione pelo menos uma opção de cada categoria.',
    generateFailed: 'Falha ao gerar startup. Por favor, tente novamente.',
  },
  loading: {
    generating: 'Gerando sua startup...',
  },
  buttons: {
    generate: 'Gerar Startup',
    testGA: 'Testar Google Analytics',
    checkEvents: 'Verificar Eventos',
  },
  debug: {
    mode: 'Modo Debug',
  },
  validation: {
    maxBusinessSectors: 'Máximo de 3 seleções de setores de negócio permitidas',
    maxCharacteristics: 'Máximo de 3 seleções de características permitidas',
    invalidBusinessSectors: 'Seleções de setores de negócio inválidas',
    invalidCharacteristics: 'Seleções de características inválidas',
  }
}; 